<template>
    <van-image-preview
        v-model="isShow"
        :images="data"
        :closeable="true"
        :startPosition="startPosition"
    ></van-image-preview>
</template>
<script>
export default {
    props: {
        data: Array
    },
    data() {
        return {
            // 初始化的索引位置
            startPosition: 0,
            // 是否显示
            isShow: false
        };
    },
    methods: {
        onShowImg(v) {
            const me = this;
            me.startPosition = v;
            me.isShow = true;
        },
        hideDialog() {
            this.isShow = false;
        }
    }
};
</script>
